import { render, staticRenderFns } from "./VDueDateColor.vue?vue&type=template&id=7bff3f4e&"
import script from "./VDueDateColor.vue?vue&type=script&lang=js&"
export * from "./VDueDateColor.vue?vue&type=script&lang=js&"
import style0 from "./VDueDateColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports